import React from 'react';

import { UserFormTypeRole } from '@/utils/user';
import RoleCard from './RoleCard';
import { SignupStepLayout } from './SignupStepLayout';

type RoleSelectionFormProps = {
  onRoleSelect: (role: UserFormTypeRole) => void;
  onSwitchToLogin?: () => void;
};

export const RoleSelectionStep: React.FC<RoleSelectionFormProps> = ({ onRoleSelect, onSwitchToLogin }) => {
  return (
    <SignupStepLayout footer={{ onSwitchToLogin, showTermsAndConditions: false }}>
      <div className="flex flex-col justify-center items-center gap-8">
        <div className="flex flex-col justify-start items-center gap-1 max-w-sm">
          <div className="self-stretch text-center text-black text-sm font-medium break-words mt-0 font-avenir">
            Choose your role
          </div>
          <div className="self-stretch text-center text-[#4A5565] text-xs font-normal leading-[1.67] break-words font-avenir">
            You can't switch roles later, but you can register a second account using a different email if needed.
          </div>
        </div>

        <div className="w-full max-w-2xl flex flex-col sm:flex-row gap-4 sm:gap-6 items-center justify-center mb-4">
          <RoleCard
            onClick={() => onRoleSelect(UserFormTypeRole.BORROWER)}
            iconSrc="/vaadin-handshake.svg"
            iconAlt="Borrow icon"
            title={'Borrower'}
            description={
              <>
                Access loans and manage your borrower profile.
                <br />
                Create and manage pools to raise capital.
              </>
            }
          />

          <RoleCard
            onClick={() => onRoleSelect(UserFormTypeRole.INVESTOR)}
            iconSrc="/invest.svg"
            iconAlt="Investor icon"
            title={'Investor'}
            description={
              <>
                Invest in vetted loans and manage your investments.
                <br />
                Individual and company investor flows supported.
              </>
            }
          />
        </div>
      </div>
    </SignupStepLayout>
  );
};
